import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { DeleteIcon } from 'ui-component/custom-icons/icons';
import NoRecordFoundIcon from 'assets/images/icons/no-records-found.svg';
import Pagination from 'ui-component/Pagination';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import { FaPlus, FaSearch } from 'react-icons/fa';
import { Skeleton, Tooltip } from '@mui/material';
import toast from 'react-hot-toast';
import usePageTitle from 'hooks/usePageTitle';
import ModelModal from './modals/ModelModal';
import useIsMobile from 'utils/isMobileUtils';
import { useQuery, useQueryClient } from 'react-query';
import Filter from 'ui-component/filter-menu/Filter';
import { ImSpinner2 } from 'react-icons/im';
import Scroller from 'ui-component/Scroller';
import SortableHeader from 'ui-component/SortableHeader';
import StatusBadge from 'ui-component/StatusBadge';
import { TbDatabaseExclamation, TbReportMoney } from 'react-icons/tb';


const SettingsModels = () => {
    const [setPageTitle] = usePageTitle('Settings');
    useEffect(() => {
        return () => {
            setPageTitle(null);
        };
    }, []);
    const queryClient = useQueryClient();
    const [params, setParams] = useSearchParams();
    const history = useNavigate();
    const [isLoading, setIsLoading] = useState(true);


    const [searchField, setSearchField] = useState();
    const [searchValue, setSearchValue] = useState();
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [activeFilters, setActiveFilters] = useState({});
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [data, setData] = useState([]);
    const [selectedData, setSelectedData] = useState(null);
    const [paginationUrl, setPaginationUrl] = useState();
    const [sortByFilter, setSortByFilter] = useState();
    const [filters, setFilters] = useState([]);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [showDetailModal, setShowDetailModal] = useState(false);


    const handleSearch = (e) => {
        let text = e.target.value;
        
        setSearchValue(text);
        setIsLoading(true);	
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }

        // Only update searchField after user stops typing for 500ms
        let timeout = setTimeout(() => {
            setSearchField(text)	
        }, 500);

        setSearchTimeout(timeout);

    };


    useEffect(() => {
        !isFirstLoad && handleFilter();
    }, [activeFilters]);

    const handleFilter = (activeF = null, searchF = null) => {
        setIsLoading(true);
        api.filterModels(activeFilters, searchField?.length > 2 ? searchField : null).then((res) => {
            setIsLoading(false);
            setData(res.data.data);
        });
    };



    const handleClose = () => { 
        setShowDeletePopup(false);
        // setShowDetailModal(false);
        setSelectedData(null)
    }
    const handleReloadList = () => { 
        setShowModal(false)
        setSelectedData(null)
        resetDataQuery();
    }

    const handleData = (data) => {
        setData(data.data);
    };

    useEffect(() => {
        getFiltersList();
    }, []);
    
	const getFiltersList = () => {
		api.getSettingsModelsFilter().then((res) => {
			setFilters(res.data);
		});
	};


    // Call this when your data changes
    const resetDataQuery = () => {
        queryClient.invalidateQueries(['settings_model', activeFilters, searchField, paginationUrl, sortByFilter]);
    };

    useEffect(() => {
        resetDataQuery();
    }, [activeFilters, searchField, sortByFilter, paginationUrl]);


	const {
		data: reqData,
		isFetching
	} = useQuery(
        ['settings_model', activeFilters, searchField, paginationUrl, sortByFilter],
		() => {
			return paginationUrl
				? api.plainAPIRequest(paginationUrl)
				: api.getSettingsModels(
					activeFilters,
					searchField?.length > 2 ? searchField : null,
					sortByFilter
				);
		},
		{
			enabled: true,
			initialData: (e) => {
				let item = null;
				setIsLoading(true);
				return item ? item : undefined;
			},
			onSuccess: (e) => {
				setIsLoading(false);
				// setLocalStorageCacheItem(md5(e?.config?.url), e, moment().add(3, 'days').format('YYYY-MM-DD'));
			},
       		staleTime: 24 * 60 * 60 * 1000, 
		}
	);



	const getItemList = reqData?.data?.data?.data;
	const paginationData = reqData?.data?.data;




    const handleCreateRecord = () => {

        setShowModal(true);
        setSelectedData(null)
    }

    const handleDelete = (id) => {
        toast.promise(
            api.settingsDeleteModel(selectedData?.id).then((res) => {
                if (res.status) {
                    setIsLoading(true);
                    handleClose();
                    resetDataQuery()
                }
                return res?.status ? res : abc;
            }),
            {
                loading: 'Deleting model...',
                success: (data) => `${data.message}`,
                error: <b>Failed to delete model</b>
            }
        );
    };

    useEffect(() => {
        if (showModal) {
          window.addEventListener('keydown', handleKeyDown);
        } else {
          window.removeEventListener('keydown', handleKeyDown);
        }
    
        // Cleanup event listener on component unmount
        return () => {
          window.removeEventListener('keydown', handleKeyDown);
        };
    }, [showModal]);

    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
          setShowModal(false);
        }
    };

    const isMobile = useIsMobile();

    return (
        <>
            
                <div className="row">
					<div className={`${isMobile ? 'col-xl-12 col-lg-12' : 'col-12 col-md-8 col-lg-8 offset-lg-2 offset-md-2'}`}>
                        <div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
                            <div className="header-bubble" />
                            <div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
                                <div
									style={{
										position: 'relative',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										marginBottom: 8,
										minHeight: 38 // ensures enough height for the button
									}}
								>
									<button
										type="button"
										aria-label="Back"
										onClick={() => history(-1)}
										className="circle-back-btn"
										style={{
											position: 'absolute',
											left: 20,
											top: '50%',
											transform: 'translateY(-50%)'
										}}
									>
										{/* Replace with your fi arrow icon, example below */}
										<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
											<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
										</svg>
									</button>
									<h5
										style={{
											textAlign: 'center',
											flex: 1,
											margin: 0,
											display: 'flex',
											gap: 10,
											justifyContent: 'center',
											alignItems: 'center'
										}}
									>
										Models
									</h5>
								</div>
                            </div>
                        </div>
                        <div className="section-head-new pl-0 mar10201316 hide-on-mobile">
                            <ul className="topListCom">
                                {/* <PermissionAllowed permissions={['Create Estimation (Button)']}> */}
                                    <button
                                        className="btn btn-primary btn-outlined-main-primary btn-create-report"
                                        onClick={() => {
                                            setShowDetailModal(true)
                                            // history(`${location.pathname}/create`);
                                        }}
                                    >
                                        <FaPlus /> New
                                    </button>
                                {/* </PermissionAllowed> */}
                            </ul>
                            <div className="actions d-none d-md-flex">
                            </div>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                gap: 10,
                                paddingTop: 0,
                                paddingBottom: 5,
                                paddingLeft: 20,
                                paddingRight: 20
                            }}
                            className="show-on-mobile"
                        >
                            <form className="form-inline navbar-search" style={{ flex: 1 }}>
                                <div style={{ position: 'relative', width: '100%' }}>
                                    <input
                                        type="text"
                                        className="form-control bg-white border"
                                        placeholder="Search"
                                        aria-label="Search"
                                        aria-describedby="basic-addon2"
                                        value={searchValue || ''}
                                        onChange={handleSearch}
                                        // onChange={(e) => {
                                        // 	setSearchField(e.target.value);
                                        // }}
                                        style={{ width: '100%', paddingRight: 36 }}
                                    />
                                    <span
                                        className="searchIcon"
                                        style={{
                                            position: 'absolute',
                                            right: 10,
                                            top: '50%',
                                            transform: 'translateY(-50%)',
                                            color: '#888',
                                            pointerEvents: 'none'
                                        }}
                                    >
                                        <FaSearch />
                                    </span>
                                </div>
                            </form>
                            <div style={{ flexShrink: 0 }}>
                                <Filter
                                    activeFilters={activeFilters}
                                    onSubmit={setActiveFilters}
                                    filters={filters}
                                    multi={undefined}
                                    source={`settings-models`}
                                    noScrolling={true}
                                />
                            </div>
                        </div>
                        <div className={`card shadow-sm  bg-white mb-4 table-card ${isMobile ? 'shorter-table' : ''}`}>
                            <div className=" align-items-center justify-content-between TableSerachBar">
                                <div>
                                    <Filter
                                        activeFilters={activeFilters}
                                        onSubmit={setActiveFilters}
                                        filters={filters}
                                        multi={undefined}
                                        source={`settings-models`}
                                        noScrolling={true}
                                    />
                                </div>
                                <form className="form-inline navbar-search" style={{ display: 'flex', gap: '5px' }} onSubmit={(e) => e.preventDefault()}>
                                    {isFetching && (
                                        <p className="m-0" style={{ display: 'flex', gap: '3px', alignItems: 'center', fontSize: '10px' }}>
                                            <ImSpinner2 className="fa-spin" />
                                        </p>
                                    )}
    
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className="form-control bg-white border"
                                            placeholder="Search"
                                            aria-label="Search"
                                            aria-describedby="basic-addon2"
                                            // value={searchField}
                                            value={searchValue || ''}
                                            onChange={handleSearch}
                                            // onChange={(e) => {
                                            // 	setSearchField(e.target.value);
                                            // }}
                                            style={{ width: '100%' }}
                                        />
                                        <span className="searchIcon">
                                            <FaSearch />
                                        </span>
                                    </div>
                                </form>
                            </div>
                            <div className="estimation-table-area">
                                <div className="table-side">
                                    <div className="table-responsive-xl tableData estimationList">
                                        <Scroller extraHeight={60}>
                                            <table className="table  min-width-unset tbl-space pm-table d-none d-md-table">
                                            {/* <table className="table pm-table"> */}
                                                <thead>
                                                    <tr className="sticky-header">
                                                        <th scope="col" width="">
                                                            <SortableHeader
                                                                name="name"
                                                                currentSortBy={sortByFilter}
                                                                onClick={() => {
                                                                    updateSortByStatus('name');
                                                                }}
                                                            >
                                                                Name
                                                            </SortableHeader>
                                                        </th>
    
                                                        <th scope="col" width="">
                                                            <SortableHeader
                                                                name="category"
                                                                currentSortBy={sortByFilter}
                                                                onClick={() => {
                                                                    updateSortByStatus('category');
                                                                }}
                                                            >
                                                                Category
                                                            </SortableHeader>
                                                        </th>
    
                                                        <th scope="col">
                                                            <SortableHeader
                                                                name="status"
                                                                currentSortBy={sortByFilter}
                                                                onClick={() => {
                                                                    updateSortByStatus('status');
                                                                }}
                                                            >
                                                                Status
                                                            </SortableHeader>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {isLoading ? (
                                                        <>
                                                            {[...Array(25)].map((e, i) => (
                                                                <tr style={{ height: '35px' }} key={i}>
                                                                    {[...Array(3)].map((e, i) => (
                                                                        <td>
                                                                            <Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '32px' }} />
                                                                        </td>
                                                                    ))}
                                                                </tr>
                                                            ))}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {getItemList?.length > 0 && (
                                                                getItemList?.map((item, index) => {
                                                                    return (
                                                                        <tr key={index} className="hover-row">
                                                                            <td
                                                                                className={'cursor-pointer align-middle font14'}
                                                                                onClick={(e) => {
                                                                                    setShowDetailModal(true);
                                                                                    setSelectedData(item)
                                                                                }}
                                                                            >
                                                                                {item?.name}
                                                                            </td>
                                                                            <td
                                                                                className={'cursor-pointer align-middle font14'}
                                                                                onClick={(e) => {
                                                                                    setShowDetailModal(true);
                                                                                    setSelectedData(item)
                                                                                }}
                                                                            >
                                                                                {item?.category}
                                                                            </td>
                                                                            <td
                                                                                className={'cursor-pointer align-middle font14'}
                                                                                onClick={(e) => {
                                                                                    setShowDetailModal(true);
                                                                                    setSelectedData(item)
                                                                                }}
                                                                            >
                                                                                <div style={{ width: '100px' }}>
                                                                                    <StatusBadge itemStatus={item?.status} />
                                                                                </div>
                                                                            </td>

                                                                            <td>
                                                                                <div>
                                                                                    <div className="hover-button">
                                                                                        
                                                                                        <Tooltip title={'Delete'} arrow placement="top">
                                                                                            <div
                                                                                                className="btn btn-danger white-var btn-sm cursor-pointer"
                                                                                                style={{ width: '34px' }}
                                                                                                onClick={() => {
                                                                                                    setShowDeletePopup(true);
                                                                                                    setSelectedData(item)
                                                                                                }}
                                                                                            >
                                                                                                <div style={{ margin: 'auto 3px' }}>
                                                                                                    <DeleteIcon height="14px" width="14px" />
                                                                                                </div>
                                                                                            </div>
                                                                                        </Tooltip>
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            )}
                                                            {getItemList?.length < 1 && (
                                                                <tr className="no-hover">
                                                                    <td colSpan={7}>
                                                                        <div className="not-found-container">
                                                                            <div className="not-found-icon">
                                                                                <img src={NoRecordFoundIcon} style={{ height: '200px', width: '200px' }} />
                                                                            </div>
                                                                            <h6 className="not-found-text">No Data Available</h6>
                                                                            <Link to={'/sales/sales-orders/create'} className="btn btn-primary btn-outlined-main">
                                                                                Create new product model ?
                                                                            </Link>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </>
                                                    )}
                                                </tbody>
                                            </table>
                                            <div className="inv-cards-list d-md-none">
                                                {
                                                    isMobile && (
                                                        <div
                                                            className="mobile-product-list"
                                                            style={{ height: 'calc(100dvh - 300px)', overflowY: 'auto', display: 'flex', flexDirection: 'column' }}
                                                        >
                                                            {isLoading ? (
                                                                [...Array(10)].map((_, i) => (
                                                                    <div
                                                                        key={i}
                                                                        className="mobile-color-card skeleton"
                                                                        style={{
                                                                            borderRadius: 12,
                                                                            background: '#f5f5f5',
                                                                            padding: 16,
                                                                            minHeight: 60
                                                                        }}
                                                                    >
                                                                        <Skeleton variant="rounded" width={'100%'} height={30} />
                                                                    </div>
                                                                ))
                                                            ) : getItemList?.length > 0 ? (
                                                                getItemList.map((row, index) => (
                                                                    <div
                                                                        key={index}
                                                                        className="mobile-product-card"
                                                                        style={{
                                                                            borderBottom: '1px solid #eee',
                                                                            padding: '10px 20px',
                                                                            background: index % 2 === 0 ? '#fff' : '#f9f9f9',
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            justifyContent: 'space-between',
                                                                            width: '100%'
                                                                        }}
                                                                    >
                                                                        <div
                                                                            style={{
                                                                                fontWeight: 500,
                                                                                fontSize: 16,
                                                                                cursor: 'pointer'
                                                                            }}
                                                                            onClick={() => {
                                                                                setShowDetailModal(true);
                                                                                setSelectedData(row)
                                                                            }}
                                                                        >
                                                                            {row?.name}
                                                                        </div>
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                                            <div
                                                                                className="btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer"
                                                                                style={{ marginLeft: 8, padding: 6, borderRadius: 6, minWidth: '40px' }}
                                                                                onClick={() => {
                                                                                    
                                                                                    setShowDeletePopup(true);
                                                                                    setSelectedData(row)
                                                                                }}
                                                                            >
                                                                                <div style={{ margin: 'auto 3px' }}>
                                                                                    <DeleteIcon height="14px" width="14px" />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            ) : (
                                                                <div style={{ textAlign: 'center', color: '#888', padding: 24 }}>
                                                                    <div className="not-found-icon" style={{ fontSize: 32, marginBottom: 8 }}>
                                                                        <img src={NoRecordFoundIcon} style={{ height: '120px', width: '120px' }} />
                                                                    </div>
                                                                    <div style={{ fontSize: 15, marginBottom: 12 }}>No Data Available</div>
                                                                    <div
                                                                        className="cursor-pointer btn btn-primary btn-outlined-main"
                                                                            onClick={() => {
                                                                                handleCreateColor();
                                                                            }}
                                                                    >
                                                                        Create New Product Model?
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )
                                                }
                                                {
                                                    !isMobile && (
                                                        getItemList?.length < 1 && (
                                                            <div className="w-100">
                                                                <div className="not-found-container">
                                                                    <div className="not-found-icon">
                                                                        <TbDatabaseExclamation />
                                                                    </div>
                                                                    <h6 className="not-found-text">No Data Available</h6>
                                                                    <button
                                                                        className="btn btn-primary btn-outlined-main"
                                                                        onClick={() => {

                                                                            handleCreateRecord();
                                                                        }}
                                                                    >
                                                                        Create New Product Model?
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        )
                                                    )
                                                }
                                            </div>
                                        </Scroller>
                                    </div>
                                    {isLoading ? (
                                        <div className="inv-cards-list d-md-none" style={{ padding: '12px 0' }}>
                                            {[...Array(15)].map((_, idx) => (
                                                <div
                                                    key={idx}
                                                    className="order-list-card"
                                                    style={{
                                                        background: idx % 2 === 0 ? '#f9f9f9' : '#fff',
                                                        marginBottom: 10,
                                                        borderRadius: 12,
                                                        padding: 16,
                                                        minHeight: 90,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: 10
                                                    }}
                                                >
                                                    {[...Array(3)].map((__, i) => (
                                                        <div key={i} style={{ width: i === 0 ? '60%' : i === 1 ? '40%' : '80%' }}>
                                                            <Skeleton variant="rounded" width={'100%'} height={18} style={{ borderRadius: '8px' }} />
                                                        </div>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <Pagination pagination={paginationData} data={handleData} onLoading={(e) => {}} reactQuery />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
                {showDeletePopup && (
                    <DeleteConfirmation
                        show={showDeletePopup}
                        handleClose={handleClose}
                        handleDelete={handleDelete}
                        title="Confirm"
                        message={`Are you sure you want to delete ${selectedData?.name}?`}
                        customDeleteButtonText={`Yes, Delete`}
                    />
                )}

                {
                    showDetailModal && (
                        <ModelModal
                            openPopup={true}
                            details={selectedData}
                            handleClose={() => {
                                setSelectedData(null)
                                setShowDetailModal(false);
                            }}
                            handleReloadList={handleReloadList}
                        />
                    )
                }
            </>
        );
};

export default SettingsModels;
